import { MapPin, Truck, Clock } from "lucide-react";
import { useContent, imgSrc } from "@/context/ContentContext";

const punten = [
  { icon: MapPin, tekst: "Werkplaats: Rijswijk (bezoek op afspraak mogelijk)" },
  { icon: Truck, tekst: "Levering & montage in overleg in regio en daarbuiten" },
  { icon: Clock, tekst: "Snelle reactie op offerteaanvragen via het formulier" },
];

export const Workshop = () => {
  const { content } = useContent();
  const foto = content?.workshop?.image || "/assets/mood.jpg";

  return (
  <section id="werkplaats" data-testid="workshop-section" className="py-20 bg-[#F4EFEA] px-6">
    <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-6 hr-reveal">
        <span className="text-xs uppercase tracking-widest text-[#9C6D3B] font-bold">
          Werkplaats & Regio
        </span>
        <h2 className="text-3xl sm:text-4xl font-normal font-display text-[#2B231D] mt-2 mb-4">
          Gevestigd in Rijswijk, actief in de hele regio
        </h2>
        <p className="text-sm text-[#6C5E52] leading-relaxed mb-6">
          De werkplaats van De Houtregisseur bevindt zich in Rijswijk (Zuid-Holland).
          Van hieruit bedienen we klanten in Rijswijk, Den Haag, Delft, Rotterdam en
          ver daarbuiten.
        </p>
        <div className="space-y-3 text-xs text-[#594E44]">
          {punten.map((p) => (
            <div key={p.tekst} className="flex items-center gap-3">
              <span className="w-5 h-5 rounded-full bg-[#2B231D] text-[#E6AF68] flex items-center justify-center">
                <p.icon size={11} />
              </span>
              <span>{p.tekst}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="lg:col-span-6 hr-reveal">
        <div className="aspect-[16/10] rounded-3xl overflow-hidden border border-[#D5C7B7] shadow-inner relative">
          <img
            src={imgSrc(foto)}
            alt="Sfeerbeeld van hout, materiaal en vorm uit de werkplaats"
            className="absolute inset-0 w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#2B231D]/40 via-transparent to-transparent" />
          <div className="absolute top-6 left-6 right-6 flex items-center justify-between">
            <span className="px-3 py-1 rounded-full bg-white/80 backdrop-blur-sm text-[11px] font-semibold text-[#2B231D] border border-white">
              Regio Rijswijk & Haaglanden
            </span>
            <span className="hidden sm:block text-xs text-white/90 font-mono bg-black/30 backdrop-blur-sm px-2 py-1 rounded-md">
              52.0368° N, 4.3275° E
            </span>
          </div>
          <div className="absolute bottom-6 left-6 bg-white/90 backdrop-blur-md p-4 rounded-2xl border border-white/80 max-w-xs shadow-sm">
            <p className="text-xs font-bold text-[#2B231D] font-display">De Houtregisseur Werkplaats</p>
            <p className="text-[11px] text-[#6C5E52] mt-0.5">Rijswijk, Zuid-Holland</p>
            <p className="text-[10px] text-[#9C6D3B] mt-2 font-medium">
              Ambachtelijke productie van maatwerk meubelen
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  );
};
